<template>
    <el-dialog width="40%" :visible.sync="is_show" title="当月销售业绩完成情况">
        <el-table stripe :data="data" v-loading="is_loading">
            <el-table-column label="销售人员">
                <template slot-scope="scope">
                    {{scope.row.uname}}
                </template>
            </el-table-column>
            <el-table-column label="计划量(吨)">
                <template slot-scope="scope">
                    {{scope.row.planNum}} 吨
                </template>
            </el-table-column>
            <el-table-column label="完成量(吨)">
                <template slot-scope="scope">
                    {{scope.row.comNum}} 吨
                </template>
            </el-table-column>
            <el-table-column label="完成比(%)">
                <template slot-scope="scope">
                    {{scope.row.comNum}} %
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer">
            <el-pagination
                @current-change="currentChange"
                hide-on-single-page
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
        </div>
    </el-dialog>
</template>

<script>
import request from '@/utils/request'
export default {
    name: 'plan_rank',
    data(){
        return {
            is_loading:false,
            data:[],
            total:0,
            is_show:false,
            selectForm:{
                pageSize:10,
                pageNum:1
            }
        }
    },
    methods:{
        showMany(){
            this.selectForm = {
                pageSize:10,
                pageNum:1
            };
            this.getData();
        },
        currentChange(page){
            this.selectForm.pageNum = page;
            this.getData();
        },
        getData(){
            this.is_loading = true;
            request.post("index/seller_figure_complete_ranking",this.selectForm).then(res=>{
                this.data = res.data.list;
                this.total = res.data.total;
                this.is_show = true;
                this.is_loading = false;
            }).catch(err=>{
                this.is_show = true;
                this.is_loading = false;
            });
        },
        pai(index){
            return (this.selectForm.pageNum-1)*this.selectForm.pageSize + index + 1;
        }
    },
    created() {

    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
